import React from 'react';
import PropTypes from 'prop-types';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';

const DataTable = ({ data, sectionTitle, footnote }) => (
  <div>
    <ViewerPrimaryColorUserStyle domStyle="color">
      <h4 className="section-title">{sectionTitle}</h4>
    </ViewerPrimaryColorUserStyle>
    <ul className="property-info">
      {data.map(({ label, value }) => (
        <li key={label}>
          <span>{label}:</span>
          {value}
        </li>
      ))}

      <ConditionalWrapper condition={Array.isArray(footnote)}>
        <p className="footnote">
          { Array.isArray(footnote) ?
              footnote.map(line => line.concat('\n   '))
            : footnote }
        </p>
      </ConditionalWrapper>
    </ul>
  </div>
);

DataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  sectionTitle: PropTypes.string.isRequired,
  footnote: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/DataTable/DataTable.js